import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import ProductsPage from "../pages/products/page";
import ContactPage from "../pages/contact/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import RefundPage from "../pages/refund/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about-us",
    element: <AboutPage />,
  },
  {
    path: "/our-services",
    element: <ServicesPage />,
  },
  {
    path: "/our-products",
    element: <ProductsPage />,
  },
  {
    path: "/contact-us",
    element: <ContactPage />,
  },
  {
    path: "/terms-of-use",
    element: <TermsPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPage />,
  },
  {
    path: "/refund-policy",
    element: <RefundPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;